import ProductDescription from './ProductDescription';

export default ProductDescription;
